import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  CustomReportsService,
  Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto,
} from '@wealthlane/api-services/wealthlane-report-service';

interface ImportPayload {
  file: File;
}

const usePostImportCustomReportJson = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto,
  unknown,
  ImportPayload,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: ImportPayload) => {
      return await handleRequest(
        CustomReportsService.postApiReportApiAppCustomReportsImportCustomReportJson({
          file: payload.file,
        })
      );
    },
    {
      onSuccess: async (
        response: Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto | undefined
      ) => {
        if (response?.isSuccess === true) {
          toast.success(<ToastComponent label='Success' message='Custom report imported.' />);
          await queryClient.invalidateQueries('getCustomReportList');
        } else if (response?.isSuccess === false && response?.error) {
          toast.error(<ToastComponent label='Error' message={response.error[0]} />);
        }
      },
      onError: (err: any) => {
        console.log('Custom report import error:', err);
      },
    }
  );
};

export default usePostImportCustomReportJson;
